export default __webpack_public_path__ + "static/media/product28.0ff19b9a.png";